var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"info-message-small",class:{
		'gradient-secondary-muted': _vm.superPrimary,
		'gradient-primary': !_vm.superPrimary,
	},style:(_vm.containerStyles)},[_c('div',{staticClass:"info-message-small-inner global-glass-background",style:(_vm.innerContainerStyles)},[_c('list-item',{attrs:{"icon":_vm.icon,"icon-color":"white","container-styles":{}}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }